// services/analyticsService.ts
// import { api } from '../api/analiticsApi';

import { api } from "../../../api/analiticsApi";

interface ClientMeta {
  userAgent: string;
  language: string;
  platform: string;
  browserBrands?: string;
  osPlatform?: string;
  isMobile?: boolean;
  arch?: string;
  model?: string;
  // и т.д.
}

let cachedHints: ClientMeta | null = null;

async function getCachedClientHints(): Promise<ClientMeta> {
  if (cachedHints) return cachedHints;

  const nav = navigator as any;
  const res: ClientMeta = {
    userAgent: nav.userAgent,
    language: nav.language,
    platform: nav.platform,
  };

  if (nav.userAgentData) {
    try {
      const highEntropy = await nav.userAgentData.getHighEntropyValues([
        'architecture', 'bitness', 'model', 'platformVersion', 'fullVersionList',
      ]);
      const parseBrands = (list?: { brand: string; version: string }[]) => 
        list?.map(b => `${b.brand} (v${b.version})`).join(', ');

      cachedHints = {
        ...res,
        browserBrands: parseBrands(nav.userAgentData.brands),
        isMobile: nav.userAgentData.mobile,
        osPlatform: nav.userAgentData.platform,
        arch: highEntropy.architecture,
        model: highEntropy.model,
      };
      return cachedHints;
    } catch (e) {
      console.warn("UA-CH failed", e);
    }
  }

  cachedHints = res;
  return cachedHints;
}

export const analytics = {
  async trackPageView(userId: number, path: string, breakpoint: string) {
    console.log('[analytics]');
    
    if (!userId) return;

    const hints = await getCachedClientHints();
    const pageName = path === '/' ? 'Home' : path.substring(1).charAt(0).toUpperCase() + path.slice(2);

    const payload = {
      pagePath: path,
      pageName,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      devicePixelRatio: window.devicePixelRatio,
      currentBreakpoint: breakpoint,
      ...hints,
    };

    try {
      await api.analiticsPost(document.title, import.meta.env.DEV ? 'dev' : 'prod' /*live'*/, userId, payload);
      console.log(`[Analytics] PageView tracked: ${pageName}`, payload);
    } catch (error) {
      console.error("[Analytics] Error sending data:", error);
    }
  },

  async trackEvent(userId: number, eventName: string, metadata?: Record<string, any>) {
    // Для трекинга кликов по кнопкам MUI, модалкам и т.д.
    try {
      await api.analiticsPost(document.title, 'event', userId, { eventName, ...metadata });
    } catch (error) {
      console.error("[Analytics Event Error]", error);
    }
  }
};